import { extendTheme } from '@chakra-ui/react';

const custumTheme = extendTheme({
  sizes: {
    sm: '355px',
    md: '480px'
  },
  breakpoints: {
    sm: '355px',
    md: '480px'
  }
});

export default custumTheme;